import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Gototop } from '../../components';
import logodesk from '../../assets/QI_logo.png';       
import logomv from '../../assets/QI_logo.png';       
import './navbar.css';

function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 1200 && window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const navCheck = document.getElementById("nav-check");
    if (navCheck) {
      navCheck.checked = false;
    }
  }, [location]);

  return (
    <div className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <input type="checkbox" id="nav-check" />
      <div className="nav-header">
        <div className="nav-title">
          <Link to="/">
            <img className="nav-logo-desktop" src={logodesk} alt="Desktop Logo" />
            <img className="nav-logo-mobileview" src={logomv} alt="Mobile Logo" />
          </Link>
        </div>
      </div>
      <div className="nav-btn">
        <label htmlFor="nav-check">
          <span></span>
          <span></span>
          <span></span>
        </label>
      </div>
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/Ourteam">Our Team</Link>
        <Link to="/Gallery">Gallery</Link>
        <Link to="/History">History</Link>
      </div>
      <Gototop />
    </div>
  );
}

export default Navbar;

